import type { ResourceAccess } from "./resourceAccess";

export interface PromptAccessSubject {
  propelAuthUserID: string;
  access?: ResourceAccess;
}

export interface PromptRowActions {
  canShare: boolean;
  canPublish: boolean;
  canEdit: boolean;
  canDelete: boolean;
  hasActions: boolean;
}

export const NO_PROMPT_ROW_ACTIONS: PromptRowActions = {
  canShare: false,
  canPublish: false,
  canEdit: false,
  canDelete: false,
  hasActions: false,
};

export function isPromptOwner(prompt: PromptAccessSubject, currentUserId: string | undefined): boolean {
  return prompt.access?.isOwner ?? prompt.propelAuthUserID === currentUserId;
}

export function isPromptSharedWithCaller(prompt: PromptAccessSubject, currentUserId: string | undefined): boolean {
  return !isPromptOwner(prompt, currentUserId);
}

export function canEditPrompt(prompt: PromptAccessSubject, currentUserId: string | undefined): boolean {
  return prompt.access?.canEdit ?? prompt.propelAuthUserID === currentUserId;
}

export function canDeletePrompt(prompt: PromptAccessSubject, currentUserId: string | undefined): boolean {
  return prompt.access?.canDelete ?? prompt.propelAuthUserID === currentUserId;
}

export function canManagePromptShares(prompt: PromptAccessSubject, currentUserId: string | undefined): boolean {
  return prompt.access?.canManageShares ?? prompt.propelAuthUserID === currentUserId;
}

export function promptRowActions(
  prompt: PromptAccessSubject,
  currentUserId: string | undefined,
  canPublishAsManaged: boolean,
): PromptRowActions {
  const canShare = canManagePromptShares(prompt, currentUserId);
  const canEdit = canEditPrompt(prompt, currentUserId);
  const canDelete = canDeletePrompt(prompt, currentUserId);
  const canPublish = canEdit && canPublishAsManaged;
  return { canShare, canPublish, canEdit, canDelete, hasActions: canShare || canPublish || canEdit || canDelete };
}
